import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';

import { Header, Footer } from 'src/components';

import styles from './MainLayout.module.scss';
import { ErrorSnakbar } from 'src/components/Error/ErrorSnakbar';
import { useSelector } from 'react-redux';

export const MainLayout = ({ children }) => {
	const onResponseData = useSelector((state) => state.onResponse.onResponse);
	const [isSnackBarOpen, setSnackBarOpen] = useState(false);
	const [severity, setSeverity] = useState('');
	const [message, setMessage] = useState('');

	useEffect(() => {
		setSnackBarOpen(onResponseData.isToaster);
		setSeverity(onResponseData.severity);
		setMessage(onResponseData.message);
	}, [onResponseData]);

	const handleSnackBarClose = () => {
		setSnackBarOpen(false);
	};

	const location = useLocation();
  	const isLandingPage = location?.pathname === '/';

	return (
		<div className={styles.body}>
			<Header />
			<div className={clsx(isLandingPage ? styles.renderAreaLanding :  styles.renderArea)}>{children}</div>
			<ErrorSnakbar
				showAlert={isSnackBarOpen}
				severity={severity}
				handleSnackBarClose={() => handleSnackBarClose}
				message={message}
			/>
			<Footer />
		</div>
	);
};

MainLayout.propTypes = {
	children: PropTypes.any,
};
